export async function checkAppVersion() {
    try {
      console.log("CHECK VERSION!@!!!!")
      const response = await fetch('/version.json');
      console.log(response);
      const serverVersion = await response.json();
      const metaVersion = document.querySelector('meta[name="app-version"]')?.content;
      const envVersion = process.env.REACT_APP_VERSION;
      let clientVersion = metaVersion || envVersion;
      console.log('Meta Version:', metaVersion, 'Env Version:', envVersion, 'Server Version:', serverVersion.version);
      if (!clientVersion) {
        console.log('Client version unavailable, forcing reload to ensure latest version');
        window.location.reload(true);
        return;
      }
      if (serverVersion.version !== clientVersion) {
        console.log('Version mismatch detected, forcing reload');
        window.location.reload(true);
      } else {
        //console.log('Versions match, no reload needed');
      }
    } catch (error) {
      console.error('Version check failed :', error);
      console.log(error)
      console.log("--------")
    }
  }